import mitt from 'mitt';

export const emitter = mitt();
export const state = {
  pendingItem: null,
  deboVolverACursoItem: false,
};